import { render, staticRenderFns } from "./SurveysResult.vue?vue&type=template&id=515773c6"
import script from "./SurveysResult.vue?vue&type=script&lang=js"
export * from "./SurveysResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports